module.exports = __webpack_public_path__ + "static/joogahetki-8ba15fbc584c9c437b7121726419bb0e.jpg";